import { useControlledSwr } from 'shared/hooks/use-controlled-swr'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import { RequestModuleEnum } from '../../../shared/enums/request-module-enum'
import { TEMPLATE_LIST_ALL_PATH } from '../api'
import { SmsTemplateListAllInterface } from '../types'

export function useSmsTemplatesListAll(shouldFetch?: boolean) {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, SmsTemplateListAllInterface>({
    method: RequestMethodsEnum.get,
  })

  const { data, mutate } = useControlledSwr(
    () => {
      if (!user) return null
      return [TEMPLATE_LIST_ALL_PATH, RequestModuleEnum.SmsTemplates]
    },
    fetcher,
    undefined,
    shouldFetch,
  )

  return { data, mutate }
}
